import { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import {
  useCreate,
  useNotify,
  SimpleForm,
  Create,
  useResourceContext,
  required,
  maxLength,
  useRefresh,
  minLength,
  useTranslate,
  AutocompleteInput,
  ReferenceInput,
} from "react-admin";
import SaveDeleteBtns from "../../saveDeleteBtns/SaveDeleteBtn";
import {
  inputTextKind,
  matchSuggestionKind,
  OptionRendererKind,
} from "../../common/OptionRendererKind";
import DynamicCode from "../common/DynamicCode";

const validateKind = [required(), minLength(36), maxLength(36)];

export default function PriceAddDialog({ open, setOpen }) {
  const [create] = useCreate();
  const notify = useNotify();
  const refresh = useRefresh();
  const resource = useResourceContext(); // cuman nama resource
  const t = useTranslate();

  const save = useCallback(
    async (values) => {
      try {
        await create(
          resource,
          { data: values },
          {
            returnPromise: true,
            onSuccess: (data) => {
              notify("ra.notification.created", {
                messageArgs: { smart_count: 1 },
              });
              setOpen(false);
              refresh();
            },
          }
        );
      } catch (error) {
        if (error.body && error.body.errors) {
          // The shape of the returned validation errors must match the shape of the form
          return error.body.errors;
        } else if (error.body.message) {
          notify(error.body.message, {
            type: "error",
          });
        }
      }
    },
    [create]
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} keepMounted={false}>
      <Create title={" "} sx={{ "& .RaCreate-main": { mt: 0 } }}>
        <SimpleForm
          warnWhenUnsavedChanges
          onSubmit={save}
          toolbar={<SaveDeleteBtns />}
          mode="onBlur"
          reValidateMode="onBlur"
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 0,
            }}
          >
            <DialogTitle>{t("mine.dialog.create_price")}</DialogTitle>
            <IconButton onClick={handleClose} sx={{ mr: "11px" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent>
            <ReferenceInput
              source="kind_id"
              reference="kinds"
              perPage={10}
              sort={{ field: "kinds.created_at", order: "ASC" }}
              // filter={{ all: "1102" }}
            >
              <AutocompleteInput
                label="mine.label.kind"
                variant="outlined"
                fullWidth
                sx={{ display: "inline-flex" }}
                validate={validateKind}
                optionValue="id"
                // optionText="code"
                optionText={<OptionRendererKind />}
                inputText={inputTextKind}
                matchSuggestion={matchSuggestionKind}
                filterToQuery={(searchText) => ({ name: searchText })}
              />
            </ReferenceInput>

            <DynamicCode dependOn="kind_id" />
          </DialogContent>
        </SimpleForm>
      </Create>
    </Dialog>
  );
}
